import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Outlet, createRootRoute } from "@tanstack/react-router";

const queryClient = new QueryClient();
export const Route = createRootRoute({
	component: () => (
		<QueryClientProvider client={queryClient}>
			<RootRoute />
		</QueryClientProvider>
	),
});

function RootRoute() {
	return (
		<div className="h-screen text-black bg-light grid grid-cols-1 lg:grid-cols-4 overflow-y-clip">
			<Outlet />
		</div>
	);
}
